export enum DashboardsPanels {
    DashboardsList = 'DASHBOARDS_LIST',
    DashboardWidgets = 'DASHBOARD_WIDGETS',
}
